import BaseError from './BaseError'

export default class UnsupportedEntityEndpointError extends BaseError {
  constructor(entity: string, apiAction: string) {
    super('Unsupported endpoint')
    this.context = { entity, apiAction }
  }
}
